module.exports = "mutation ($id: ID!, $data: ShopSyncOptions!) {\n  ShopSync(id: $id, data: $data)\n}\n"